/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { createContext } from 'react'

export interface PageContextValue {
  url: string
  stateName: string
  stateParams: Record<string, any>
  user: any
  isCheckmated: boolean | null
  isStagingContextSelected: boolean | null
  isStagingUploader: boolean
  isStagingUser: boolean
  isRcrUser: boolean
  policies: Record<string, any>
  authTypes: { allowedAuthTypes: string[] }
  featuresInfo: any
  unreadNotifCount: number | null
}

export const PageContext = createContext<PageContextValue | null>(null)
